import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNumber1Circle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="number-1-circle"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M11.7344 16.2275V9.26074H11.6348L9.53125 10.749V9.3252L11.7402 7.77246H13.2461V16.2275H11.7344Z" fill="currentColor"/></CentralIconBase>;
};

export default IconNumber1Circle;
